import PersonalCalendar from '@/components/PersonalCalendar/index.vue'

export default {
  name: 'index',
  components: {
    PersonalCalendar,
  },
}
